import { getPanelTrackingIdProperty } from '../panel-tracking-id';
import { productData } from '../product-data';
import { getServingConfigProperty } from '../serving-config';
import {
  getLoadingStateWrapper,
  panelStyleConstants,
} from '../tenants/puma/added-to-basket-notification';

export const SUGGEST_PROVIDER_PROPERTIES = {
  loadingStateWrapper: getLoadingStateWrapper({
    provider: 'self',
    property: 'panelName',
  }),
  ...getServingConfigProperty(),
  ...getPanelTrackingIdProperty(panelStyleConstants),
  productData: productData(),
};
